import styled from 'styled-components';
import { ReactComponent as RawAccountsSVG } from '../../../../assets/icons/icon_accounts.svg';

export const IconAccounts = styled(RawAccountsSVG)``;
